// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"9b9a146f","1872":"46932d3c","2130":"641ac481","2169":"46932d3c","2575":"e4d21118","3899":"fd3dc53e","5344":"9b9a146f","5447":"9ed0717f","7274":"9b9a146f"}[chunkId] + ".chunk.css";
};